var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('company-feature-setup-form',{attrs:{"company":_vm.company},on:{"update":_vm.updateFormData}})}
var staticRenderFns = []

export { render, staticRenderFns }